export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  /** Seconds before a retry makes sense (429, 503), when the server said so. */
  readonly retryAfterSeconds: number | null;
  constructor(
    message: string,
    status: number,
    code = 'HTTP_ERROR',
    retryAfterSeconds: number | null = null,
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.retryAfterSeconds = retryAfterSeconds;
  }
}
